export default __webpack_public_path__ + "static/media/mail.8fef95e7.svg";